module.exports = __webpack_public_path__ + "static/img/2.0167ead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-de/2.jpg
// module id = MgLF
// module chunks = 1